import { message } from "antd";
import * as actionTypes from "./types";

export const getSkills =
	() =>
	(dispatch, _getState, { getFirestore }) => {
		const database = getFirestore();

		database
			.collection("OrganisationData")
			.doc("skills")
			.get()
			.then((doc) => {
				let skills = doc.data().skills;

				dispatch({
					type: actionTypes.SET_SKILLS,
					payload: skills,
				});
			})
			.catch((err) => {
				console.log("Skills loading error ", err);
				message.error("Error while loading skills data !");
			});
	};

export const getBranches =
	() =>
	(dispatch, _getState, { getFirestore }) => {
		const database = getFirestore();

		database
			.collection("OrganisationData")
			.doc("branches")
			.get()
			.then((doc) => {
				let branches = doc.data().branches;

				dispatch({
					type: actionTypes.SET_BRANCHES,
					payload: branches,
				});
			})
			.catch((err) => {
				console.log("Branches loading error ", err);
				message.error("Error while loading branches data !");
			});
	};

export const getColleges =
	() =>
	(dispatch, _getState, { getFirestore }) => {
		const database = getFirestore();

		database
			.collection("OrganisationData")
			.doc("colleges")
			.get()
			.then((doc) => {
				let colleges = doc.data().colleges;

				dispatch({
					type: actionTypes.SET_COLLEGES,
					payload: colleges,
				});
			})
			.catch((err) => {
				console.log("Colleges loading error ", err);
				message.error("Error while loading colleges data !");
			});
	};
